export default "__VITE_ASSET__DBvL7JZP__"